import React from 'react'
import AgTechMetric from '@agtech/web/components/Metrics/AgTechMetric';
import SaleLotViewGrid from '../../lots/components/grid/SaleLotViewGrid';
import { useLotDataGetSaleLotDataQuery } from '@sales/data/lots/LotDataQueries';
import AgTechQueryLoadingSurface from '@agtech/core/data/queries/AgTechQueryLoadingSurface';
import LotManagementDialog from '../../lots/dialogs/LotManagementDialog';

export const SaleOverviewPage = () => {
    const saleOverviewPageQuery = useLotDataGetSaleLotDataQuery();

    return (
        <AgTechQueryLoadingSurface query={saleOverviewPageQuery}>
            {(saleData) => {
                const saleBidders = Object.values(saleData.bidders);
                const saleLots = Object.values(saleData.lots);

                return (
                    <div className='stretched column-based flex'>
                        <div className='flexed area-left flex'>
                            <SaleLotViewGrid />
                        </div>
                    <div className='vertical-pane row-based area-right w-[240px] flex'>
                            <AgTechMetric header='Registered Bidders' value={saleBidders.length.toString()} />
                            <AgTechMetric header='Lots In Sale' value={saleLots.length.toString()} />
                            <AgTechMetric header='Lots Sold' value={saleLots.filter(lot => !!lot.purchasePrice).length.toString()} />
                            <div className='flexed flex' />
                            <LotManagementDialog.Button classes='button-block button-highlight'/>
                        </div>
                    </div>
                )
            }}
        </AgTechQueryLoadingSurface>
    )
}
